import Alert from './Alert'

export default class Error extends Alert {
  constructor(title,text) {
    super('error',title,text)
  }
}